import { Helmet } from "react-helmet";
import Clients from "../components/Clients2";
import "../styles/AboutNew.css";
import Team1 from "../assets/img/team1.webp";
import Team2 from "../assets/img/team2.webp";
import Team3 from "../assets/img/team3.webp";
import Team4 from "../assets/img/team4.webp";

const About = () => {
  return (
    <div className="about-main">
      <Helmet>
        <title>Colorkaar | About</title>
        <meta
          name="description"
          content="Colorkaar - Color Grading Boutique Commercials , Films and Webseries Color Grading Services"
        />
      </Helmet>

      <div className="about-main-desktop">
        <div className="about-banner section-gap">
          <div>
            <h3 className="heading-h3">High-end Color. Fast Turnarounds. Zero Fuss.
            </h3>
            <p className="paragraph-p">
              Colorkaar is a color grading boutique based in Mumbai, crafting bold, polished visuals for filmmakers, brands, and creatives around the world.
            </p>
          </div>
          <img
            src="https://colorkaar.com/about-banner.webp"
            alt="colorkaar-profile-studio-setup"
            className="about-banner-img"
            loading=""
          />
          <div>
            <h3 className="heading-h3">A Studio That Keeps It Personal
            </h3>
            <p className="paragraph-p">
              Colorkaar was founded by Uday Oswal, a colorist with a cinematographer’s eye and a decade-long obsession with how visuals breathe, shift, and hold emotion.
              What began as a love for image processing soon evolved into a career rooted in color, craft, and creative precision. With over 9 years in post-production, Uday has shaped the final look of hundreds of projects, from commercials and films to music videos and branded content.
              <br /><br />Before starting Colorkaar, he trained as a cinematographer, a background that gives him a rare advantage in the grade. He doesn’t just read scopes or tweak curves, he understands how the image was lit, framed, and felt on set. That intuition helps him translate a director’s intent into visual tone with clarity and care.
            </p>
          </div>
        </div>
        <div className="about-banner">

          <div className="text-center">
            <h3 className="heading-h3">Why Work With Colorkaar?</h3>
          </div>
          <section className="about-why section-gap">
            <div className="about-why-card">
              <h3 className="subheading-h3">Expert-Led Craft
              </h3>
              <br />
              <p className="paragraph-p">
                Over 9 years of hands-on experience, with a cinematographer’s instinct behind every grade. It’s not just about how it looks, but how it feels.
              </p>
            </div>
            <div className="about-why-card">
              <h3 className="subheading-h3">Fast, Aligned, Reliable
              </h3>
              <br />
              <p className="paragraph-p">
                We move quickly without cutting corners, keeping deadlines tight and feedback loops clear, so your project stays on track.
              </p>
            </div>
            <div className="about-why-card">
              <h3 className="subheading-h3">Remote-First & Collaborative
              </h3>
              <br />
              <p className="paragraph-p">Designed to work seamlessly across time zones. Our remote workflow is smooth, secure, and built for real creative collaboration, wherever you are.
              </p>
            </div>
          </section>
          <h3 className="heading-h3">Our Philosophy</h3>
          <section className="features-section section-gap">
            <div className="feature-row">
              <div className="feature-video square">
                {/* <iframe src="https://www.youtube.com/embed/dQw4w9WgXcQ" title="Intentional Color"
                frameborder="0" allowfullscreen></iframe> */}
                <video autoPlay muted loop playsInline>
                  <source src="https://colorkaar.com/featureic.mp4" type="video/mp4" />
                </video>
              </div>
              <div className="feature-text">
                <h3 className="subheading-h3">Intentional Color</h3>
                <p className="paragraph-p">No templates. No overdone looks. Every grade is crafted to feel authentic, serving the story, the sequence, and the emotion behind every frame.
                </p>
              </div>
            </div>

            <div className="feature-row feature-reverse">
              <div className="feature-text">
                <h3 className="subheading-h3">Boutique by Design
                </h3>
                <p className="paragraph-p">You collaborate directly with the colorist, no layers, no miscommunication. Just a personal, focused process that keeps your vision front and center.
                </p>
              </div>
              <div className="feature-video square">
                {/* <iframe src="https://www.youtube.com/embed/dQw4w9WgXcQ" title="Every Frame in Context"
                frameborder="0" allowfullscreen></iframe> */}
                <video autoPlay muted loop playsInline>
                  <source src="https://colorkaar.com/featurebbd.mp4" type="video/mp4">
                  </source>
                </video>
              </div>
            </div>

            <div className="feature-row">
              <div className="feature-video square">
                {/* <iframe src="https://www.youtube.com/embed/dQw4w9WgXcQ" title="Story-Led Choices"
                frameborder="0" allowfullscreen></iframe> */}
                <video autoPlay muted loop playsInline>
                  <source src="https://colorkaar.com/featurepmc.mp4" type="video/mp4">
                  </source>
                </video>
              </div>
              <div className="feature-text">
                <h3 className="subheading-h3">Precision Meets Creativity

                </h3>
                <p className="paragraph-p">We balance the art and science of color, shaping tone with taste while ensuring workflows stay efficient, accurate, and delivery-ready.</p>
              </div>
            </div>
          </section>
        </div>


        <h3 className="heading-h3 text-align-center">Our Team</h3>
        <section className="team-section section-gap">
          <div className="team-grid">
            {[
              {
                imgAlt: "colorkaar-focus",
                imgURL: Team1,
                name: "Uday Oswal",
                designation:
                  "Founder and Senior Colorist",
              }, {
                imgAlt: "colorkaar-focus",
                imgURL: Team3,
                name: "Pramey Wadibhasme",
                designation:
                  "Colorist",
              }, {
                imgAlt: "colorkaar-focus",
                imgURL: Team4,
                name: "Yugam Jain",
                designation:
                  "Online Editor",
              }, {
                imgAlt: "colorkaar-focus",
                imgURL: Team2,
                name: "Priyanka Sambyal",
                designation:
                  "Head of Client Relations",
              },
              // {
              //   imgAlt: "colorkaar-focus",
              //   imgURL: WWC1,
              //   name: "Gunjan",
              //   designation:
              //     "Booking Manager",
              // }

            ].map((m, i) => (
              <div className="team-member">
                <img src={m.imgURL} alt={m.imgAlt} />
                <h3 className="subheading-h3">{m.name}</h3>
                <p className="paragraph-p">{m.designation}</p>
              </div>
            ))}
          </div>
        </section>
        <h3 className="heading-h3 text-align-center">SOME OF OUR CLIENTS</h3>
        <Clients />
      </div>
    </div>
  );
};

export default About;
